import { useTranslation } from 'react-i18next';
import { cx } from '@platform/core/lib/cx';
import { useModuleStrings } from '@platform/modularity/useModuleStrings';
import type { IViewCardFieldsProps } from './IViewCardFieldsProps';
import { toggleColumn } from './viewDraft';

/** «Поля на картках» (прототип v4): пігулки 30px із прапорцем — вибрані з рамкою акценту, невибрані напівпрозорі; «Заголовок показується завжди». */
export function ViewCardFields({ rt, fields, onChange }: IViewCardFieldsProps) {
  const { t } = useTranslation();
  const strings = useModuleStrings();
  return (
    <div className="lv-vs__field">
      <span className="lv-vs__caption">{t('listViews.vs.cardFields')}</span>
      <div className="lv-vs__pills">
        {rt.fields.filter((f) => f.key !== 'title' && f.type !== 'textarea' && f.type !== 'json' && !f.hidden).map((f) => {
          const on = fields.includes(f.key);
          return (
            <label key={f.key} className={cx('lv-vs__pill', on && 'is-on')}>
              <input type="checkbox" checked={on} onChange={() => onChange(toggleColumn(fields, f.key))} />
              {strings.field(rt.key, f.key, f.label)}
            </label>
          );
        })}
      </div>
      <span className="lv-vs__hint">{t('listViews.vs.titleAlways')}</span>
    </div>
  );
}
